import React from "react";
import ReactDOM from "react-dom";
import "react-toastify/dist/ReactToastify.min.css";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import App from "./App";
import "./ThemeColors/ThemeColors.css";
import { QueryClientProvider, QueryClient, MutationCache } from "react-query";
import { DASHBOARD_STATS } from "./lib/constants";
import { ReactQueryDevtools } from "react-query/devtools";
import { Provider } from "react-redux";
import { store } from "./store/store";
import theme from "./ThemeColors/Theme";
import { ToastContainer } from "react-toastify";

const queryClient = new QueryClient({
  // Any saved change (a new client, case, staff member...) can move the
  // dashboard figures, so refresh them after every successful save.
  mutationCache: new MutationCache({
    onSuccess: () => queryClient.invalidateQueries(DASHBOARD_STATS),
  }),
  defaultOptions: {
    queries: {
      // Reuse data fetched in the last minute instead of downloading the same
      // list again (Cases and Clients are several MB each). Saving a change
      // still refreshes the affected lists straight away, because every
      // mutation invalidates its queries.
      staleTime: 60 * 1000,
      // Don't re-download every open list each time the user switches back
      // to the browser tab.
      refetchOnWindowFocus: false,
      // One retry instead of three with growing delays, so a failed request
      // shows its error in seconds rather than after a long spinner.
      retry: 1,
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      <BrowserRouter>
        <ChakraProvider theme={theme}>
          <React.StrictMode>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <App />
          </React.StrictMode>
        </ChakraProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);
